import React from 'react';

import CLocalizedTextStringStatic from '../../../../../components/CLocalizedTextStringStatic';
import CMarkdownText from '../../../../../components/CMarkdownText';
import CPageModule from '../../../../../components/CPageModule';
import CTextFieldDisplay from '../../../../../components/CTextFieldDisplay';

interface Props {
  economicTargetAllocation: string;
  maximumLeverage: string;
  indexOptionPosition: string;
}

export default function CFactsheetOverviewKeyInfo(props: Props) {
  const etaLabel = CLocalizedTextStringStatic('fsovAllocH1');
  const maxLevLabel = CLocalizedTextStringStatic('fsovAllocH2');
  const ixOptionPos = CLocalizedTextStringStatic('fsovAllocH3');

  return (
    <CPageModule fullWidth style={{ paddingTop: 0, paddingBottom: 0 }}>
      <CTextFieldDisplay label={etaLabel}>
        <CMarkdownText>{props.economicTargetAllocation}</CMarkdownText>
      </CTextFieldDisplay>
      <CTextFieldDisplay label={maxLevLabel}>
        <CMarkdownText>{props.maximumLeverage}</CMarkdownText>
      </CTextFieldDisplay>
      <CTextFieldDisplay label={ixOptionPos}>
        <CMarkdownText>{props.indexOptionPosition}</CMarkdownText>
      </CTextFieldDisplay>
    </CPageModule>
  );
}
